import { SET_SELECTED_FRANCHISE , RESET_FRANCHISE } from "../actions/franchiseActions";

const initialState = {
  selectedFranchise: null,
};

const franchiseReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECTED_FRANCHISE:
      return {
        ...state,
        selectedFranchise: action.payload,
      };

       case RESET_FRANCHISE:
      return initialState;
    default:
      return state;
  }
};

export default franchiseReducer;
